   var consent_ver = "1.02";
! function(n) {
    "use strict";
    var e = "https://consent-service.colibrilearning.com/v1/consent-link",
        t = /^https:\/\/[a-z0-9.-]*keycloak\.colibrilearning\.com\/realms\//i,
        r = /^https:\/\/[a-z0-9.-]*via\.colibrilearning\.com\//i,
        o = {},
        i = "undefined" != typeof window ? window : null,
        l = "undefined" != typeof document ? document : null;

    function u(n) {
        try {
            return decodeURIComponent(n)
        } catch (e) {
            return n
        }
    }

    function a(n) {
        return {
            status: "skipped",
            reason: n
        }
    }

    function c(n) {
        if (null == n) return !0;
        if ("string" != typeof n) return !1;
        var e = n.trim().toLowerCase();
        return "" === e || "null" === e || "undefined" === e
    }

    function s(n, e) {
        var t = null != e ? e : l ? l.cookie : "";
        if (!t) return null;
        var r = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"),
            o = t.match(new RegExp("(?:^|;)\\s*" + r + "=([^;]*)"));
        return o ? o[1] : null
    }

    function d(n) {
        var e = null != n ? n : l ? l.cookie : "";
        if (!e) return "";
        for (var t, r = [], o = new RegExp("(?:^|;)\\s*OptanonConsent=([^;]+)", "g"); t = o.exec(e);) r.push(t[1]);
        if (r.length < 2) return r[0] || "";
        for (var i = 0; i < r.length; i++)
            if (/C00\d/.test((r[i].match(/groups=([^&]+)/) || [])[1] || "")) return r[i];
        return r[0]
    }

    function p(n) {
        function e(e) {
            var t = n.match(new RegExp("(?:^|&)" + e + "=([^&]*)"));
            return t ? t[1] : ""
        }
        n = n || "";
        var t = e("consentId"),
            r = e("version"),
            o = e("geolocation"),
            i = e("intType"),
            l = parseInt(e("interactionCount"), 10),
            a = e("datestamp"),
            c = null;
        if (a) {
            var s = new Date(u(a.replace(/\+/g, " ")));
            isNaN(s.getTime()) || (c = s.toISOString())
        }
        return {
            consentId: t || null,
            groups: u(e("groups")),
            gpc: /(?:^|&)browserGpcFlag=1(?:&|$)/.test(n),
            cmpVersion: r || null,
            geo: o ? u(o) : null,
            interactionType: i || null,
            interactionCount: isNaN(l) ? 0 : l,
            occurredAt: c
        }
    }

    function f(n) {
        var e = n;
        e || (e = (i && i.dataLayer || []).concat(i && i.consentDataLayer || []));
        for (var t = ["user_id", "email", "username", "login_id_type", "login_state", "consent_token", "consent_capture_enabled"], r = {}, o = e.length - 1; o >= 0; o--) {
            var l = e[o];
            if (l && "object" == typeof l)
                for (var u = 0; u < t.length; u++) {
                    var a = t[u];
                    a in r || c(l[a]) || (r[a] = l[a])
                }
        }
        return r
    }

    function g(n, e) {
        var t = s(n, e);
        return null == t ? null : u(t)
    }

    function m(n) {
        var e = String(n).replace(/-/g, "+").replace(/_/g, "/"),
            t = e.length % 4;
        t && (e += new Array(5 - t).join("="));
        var r = "undefined" != typeof atob ? atob : i && i.atob;
        if ("function" != typeof r) return null;
        try {
            for (var o = r(e), l = "", u = 0; u < o.length; u++) {
                var a = o.charCodeAt(u).toString(16);
                l += "%" + (a.length < 2 ? "0" + a : a)
            }
            return decodeURIComponent(l)
        } catch (n) {
            return null
        }
    }

    function y(n) {
        var e = g("access_token", n);
        if (!e) return null;
        var r = e.split(".");
        if (3 !== r.length) return null;
        var o, i = m(r[1]);
        if (!i) return null;
        try {
            o = JSON.parse(i)
        } catch (n) {
            return null
        }
        return t.test(o.iss) ? o.exp && o.exp + 60 < Math.floor(Date.now() / 1e3) || null == o.studentId || "" === o.studentId ? null : {
            user_id: String(o.studentId),
            email: o.email || null,
            username: o.preferred_username || null,
            login_id_type: "global",
            login_state: "authenticated",
            consent_token: e
        } : null
    }

    function _(n) {
        var e = g("X-Credential", n);
        if (!e) return null;
        var t = e.split(":"),
            r = t[0] ? t[0].replace(/^\s+|\s+$/g, "") : "",
            o = t[1] ? t[1].replace(/^\s+|\s+$/g, "") : "";
        return "Student" === r && o ? {
            user_id: o,
            email: null,
            username: null,
            login_id_type: "order",
            login_state: "authenticated",
            consent_token: null
        } : null
    }

    function v(n) {
        var e, t = g("SESSmO", n);
        if (!t) return null;
        try {
            e = JSON.parse(t)
        } catch (n) {
            return null
        }
        var o = e && e.id_token;
        if (!o || "string" != typeof o) return null;
        var i = o.split(".");
        if (3 !== i.length) return null;
        var l, u = m(i[1]);
        if (!u) return null;
        try {
            l = JSON.parse(u)
        } catch (n) {
            return null
        }
        if (!r.test(l.iss)) return null;
        if (l.exp && l.exp + 60 < Math.floor(Date.now() / 1e3)) return null;
        var a = null != l.sub && "" !== l.sub ? l.sub : l.guid;
        return null == a || "" === a ? null : {
            user_id: String(a),
            email: l.email || null,
            username: null,
            login_id_type: "global",
            login_state: "authenticated",
            consent_token: null
        }
    }

    function h(n) {
        var e, t = null != (n = n || {}).cookie ? n.cookie : void 0,
            r = f(n.dataLayer),
            o = y(t) || v(t) || (!(e = r) || null == e.user_id && null == e.email && null == e.username ? null : e) || _(t) || {};
        return o.consent_capture_enabled = r.consent_capture_enabled, o
    }

    function k(n) {
        if (!(n = n || l) || !n.querySelector) return null;
        var e = n.querySelector("script[data-domain-script]");
        return e ? e.getAttribute("data-domain-script") : null
    }

    function I(n) {
        n = n || {};
        try {
            var t = d(null != n.cookie ? n.cookie : void 0),
                r = p(t),
                l = s("OptanonAlertBoxClosed", null != n.cookie ? n.cookie : void 0),
                u = h(n),
                c = u.user_id,
                f = u.email,
                g = u.consent_capture_enabled;
            if (!1 === g || "false" === String(g).toLowerCase()) return a("consent_capture_disabled");
            if (!r.consentId) return a("no_consentId");
            if (!r.groups) return a("no_groups");
            if (!c && !f && !u.username) return a("no_identity");
            var m = null != n.storage ? n.storage : i ? i.sessionStorage : null,
                y = "cid_" + r.consentId + "_" + (c || f || u.username) + "_" + r.groups;
            if (m) try {
                if (m.getItem(y)) return a("deduped")
            } catch (n) {}
            if (o[y]) return a("in_flight");
            var _ = n.fetch || ("undefined" != typeof fetch ? fetch : i ? i.fetch : null);
            if ("function" != typeof _) return a("no_fetch");
            var v = {
                consentId: r.consentId,
                groups: r.groups,
                userRef: c || null,
                email: f || null,
                username: u.username || null,
                loginIdType: u.login_id_type || null,
                consentToken: u.consent_token || null,
                gpc: r.gpc,
                cmpDomainId: null != n.cmpDomainId ? n.cmpDomainId : k(n.doc),
                cmpVersion: r.cmpVersion,
                geo: r.geo,
                interactionType: r.interactionType,
                interactionCount: r.interactionCount,
                occurredAt: r.occurredAt,
                alertBoxClosed: l,
                rawConsent: t || null,
                pageUrl: null != n.pageUrl ? n.pageUrl : i && i.location ? i.location.href : null,
                domain: null != n.domain ? n.domain : i && i.location ? i.location.hostname : null,
                source: "authenticated" === u.login_state ? "login" : "guest"
            };
            return o[y] = 1, {
                status: "sending",
                promise: _(e, {
                    method: "POST",
                    keepalive: !0,
                    credentials: "omit",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(v)
                }).then(function(n) {
                    if (delete o[y], n && !1 === n.ok) return {
                        status: "error"
                    };
                    if (m) try {
                        m.setItem(y, "1")
                    } catch (n) {}
                    return {
                        status: "sent"
                    }
                }, function() {
                    return delete o[y], {
                        status: "error",
                        reason: "network"
                    }
                }),
                payload: v,
                key: y
            }
        } catch (n) {
            return {
                status: "error"
            }
        }
    }

    function w(n) {
        var e = (n = n || {}).run || I,
            t = n.window || i;
        if (!t || "function" != typeof t.setInterval) return null;
        var r = n.interval || 2e3,
            o = n.maxAttempts || 30,
            l = 0,
            u = t.setInterval(function() {
                l++;
                var r = e(n.runOpts);
                (!r || "skipped" !== r.status || "no_identity" !== r.reason || l >= o) && t.clearInterval(u)
            }, r);
        return u
    }

    function b(e) {
        var t = (e = e || n).OptanonWrapper;
        if ("function" == typeof t && t._ccChained) return t;

        function r() {
            if ("function" == typeof t) try {
                t.apply(this, arguments)
            } catch (n) {}
            try {
                I()
            } catch (n) {}
        }
        return r._ccChained = !0, e.OptanonWrapper = r, r
    }
    var C = {
        pickOptanon: d,
        parseOptanon: p,
        readIdentity: f,
        identityFromJwt: y,
        identityFromMiniOrange: v,
        identityFromXCredential: _,
        resolveIdentity: h,
        run: I,
        startIdentityPoll: w,
        install: b,
        config: {
            ENDPOINT: e
        }
    };
    if ("undefined" != typeof module && module.exports) module.exports = C;
    else if (i && !i.__colibriCT) {
        i.__colibriCT = C, b(i);
        try {
            if (d()) {
                var S = I();
                S && "skipped" === S.status && "no_identity" === S.reason && w()
            }
        } catch (n) {}
    }
}("undefined" != typeof window ? window : this);